import type SuperJSON from "superjson";
import { Temporal } from "temporal-polyfill";

/**
 * Register the SuperJSON transformer for Temporal.PlainDate.
 * Pass the SuperJSON instance you want to register on (client or server instance).
 */
export function registerPlainDateTransformer(
  superjson: typeof SuperJSON
): void {
  superjson.registerCustom<Temporal.PlainDate, string>(
    {
      isApplicable: (v): v is Temporal.PlainDate =>
        v instanceof Temporal.PlainDate,
      serialize: (d) => d.toString(),
      deserialize: (s) => Temporal.PlainDate.from(s),
    },
    "Temporal.PlainDate"
  );
}
